(() => {
  angular
    .module('gm.common.items')
    .factory('GmyProducts', GmyProducts);

  function GmyProducts(
    gmApi,
    GmyImportExport,
    GmyToken,
    promiseCache,
    Upload
  ) {
    'ngInject';

    return {
      add,
      addShippingSetting,
      delete: deleteProduct,
      getAll,
      getById,
      getCategories,
      getExportUrl,
      getByMerchantAndId,
      getMerchantShippingSettings,
      getMerchantTaxes,
      getRegions,
      getShippingSettings,
      getTaxes,
      importList,
      removeShipping,
      update,
      updateTaxes,
    };

    function add(product) {
      const file = product.image;
      const productCopy = angular.copy(product);

      delete productCopy.image;

      const data = Upload.json(productCopy);

      return Upload
        .upload({
          url: `${gmApi.getApiBasePath()}users/products`,
          data: { data, file },
          headers: { 'X-Auth-Token': GmyToken.getToken() }
        })
        .then(clearCache);
    }

    function addShippingSetting(shipping) {
      return gmApi.post('users/products/shipping', shipping, { auth: true });
    }

    function clearCache() {
      return promiseCache.remove('products');
    }

    function deleteProduct(product) {
      return gmApi.delete(`users/products/${product.id}`, { auth: true }).then(clearCache);
    }

    function getAll() {
      return promiseCache({
        promise: () => gmApi.get('users/products'),
        ttl: 600000,
        key: 'products'
      });
    }

    function getById(id) {
      return gmApi.get(`users/products/${id}`);
    }

    function getCategories() {
      return gmApi.get('users/products/categories')
      .then(categories => categories.filter(c => c).map(c => ({ id: c, name: c })));
    }

    function getExportUrl() {
      return GmyImportExport.getExportUrl('users/products/export');
    }

    function getByMerchantAndId(merchantId, id) {
      return gmApi.get(`users/products/${merchantId}/${id}`);
    }

    function getMerchantShippingSettings(merchantId) {
      return gmApi.get(`users/${merchantId}/products/shipping`).then(({ shipping }) => shipping);
    }

    function getMerchantTaxes(merchantId) {
      return gmApi.get(`users/${merchantId}/products/taxes`);
    }

    function getRegions() {
      return gmApi.get('regions');
    }

    function getShippingSettings() {
      return gmApi
        .get('users/products/shipping')
        .then(({ shipping }) => shipping.sort(sortCountryRegion));
    }

    function getTaxes() {
      return gmApi.get('users/products/taxes/all').then((taxes) => {
        taxes.regional.sort(sortCountryRegion);

        return taxes;
      });
    }

    function importList(file) {
      return GmyImportExport.uploadImport('users/products/import', file).then(clearCache);
    }

    function removeShipping(shipping) {
      return gmApi.delete(`users/products/shipping/${shipping.id}`, { auth: true });
    }

    function sortCountryRegion(a, b) {
      if (a.region && b.country) {
        return -1;
      }

      if (b.region && a.country) {
        return 1;
      }

      if (a.region && b.region) {
        return a.region.localeCompare(b.region);
      }

      if (a.country && b.country) {
        return a.country.localeCompare(b.country);
      }

      return 0;
    }

    function update(product) {
      const file = product.image;
      const productCopy = angular.copy(product);

      delete productCopy.image;

      const data = Upload.json(productCopy);

      return Upload
        .upload({
          url: `${gmApi.getApiBasePath()}users/products/${product.id}`,
          data: { data, file },
          method: 'PUT',
          headers: { 'X-Auth-Token': GmyToken.getToken() }
        })
        .then(clearCache);
    }

    function updateTaxes(taxes) {
      return gmApi.post('users/products/taxes/all', taxes, { auth: true });
    }
  }
})();
